import { createRouter, createWebHistory } from 'vue-router'

import layout from '../layout/layout.vue'
import layout_EN from '../layout/layout_EN.vue'
import layout_de from '../layout/layout_DE.vue'
import layout_cht from '../layout/layout_cht.vue'
import Aside from '../layout/Aside.vue'
const routes = [
  {
    path: '/',
    name: 'layout',
    component: layout,
    redirect:'/Home',
    children:[
      {
        path: '/Home',
        name: 'Home',
        component: () => import("../ZH-CN/Home_CN"),
      },

      //  公司简介
      {
        path: '/About',
        name: 'About',
        component: () => import("../ZH-CN/About"),
      },



      //  联系我们
      {
        path: '/Contact',
        name: 'Contact',
        component: () => import("../ZH-CN/Contact"),
      },
      //  新闻
      {
        path: '/News',
        name: 'News',
        component: () => import("../ZH-CN/News_CN"),

      },
      //  新闻详情
      {
        path: '/NewsDescription',
        name: 'NewsDescription',
        component: () => import("../ZH-CN/news/NewsDescription"),

      },
      //  产品
      {
        path: '/Products',
        name: 'Products',
        component: () => import("../ZH-CN/Products"),

        children:[
          //  制图
          {
            path: '/Products/Page1',
            name: 'Page1',
            meta: {
              keepAlive: true,
              left: true,
              crumbs:false
            },
            component: () => import("../ZH-CN/calc/Page1"),
          },
          {
            path: '/Products/Page2',
            name: 'Page2',
            meta: {
              keepAlive: true,
              left: true,
              crumbs:false
            },
            component: () => import("../ZH-CN/calc/Page2"),
          },
        ]
      },
      //
      {
        path: '/Calc/Page1/detail',
        name: 'page1/EE',
        component: () => import("../ZH-CN/calc/Page1/EE"),

      },
      {
        path: '/Calc/Page1/1',
        name: 'page1/1',
        component: () => import("../ZH-CN/calc/Page1/mate"),

      },

      //  隐私条款
      {
        path: '/PrivacyPolicy',
        name: 'PrivacyPolicy',
        component: () => import("../ZH-CN/PrivacyPolicy"),

      },


      {
        path: '/Calc/page/EE',
        name: 'page/EE',
        component: () => import("../ZH-CN/forIfcores/Page1/EE"),
      },
      {
        path: '/Calc/page/UF',
        name: 'page/UF',
        component: () => import("../ZH-CN/forIfcores/Page1/UF"),
      },
      {
        path: '/Calc/page/EC',
        name: 'page/EC',
        component: () => import("../ZH-CN/forIfcores/Page1/EC"),
      },
      {
        path: '/Calc/page/H',
        name: 'page/H',
        component: () => import("../ZH-CN/forIfcores/Page1/huan"),
      },
      {
        path: '/Calc/page/PQ',
        name: 'page/PQ',
        component: () => import("../ZH-CN/forIfcores/Page1/PQ"),
      },
      {
        path: '/Calc/page/EQ',
        name: 'page/EQ',
        component: () => import("../ZH-CN/forIfcores/Page1/EQ"),
      },
      {
        path: '/Calc/page/UY',
        name: 'page/UY',
        component: () => import("../ZH-CN/forIfcores/Page1/UY"),
      },
//   变压器
      {
        path: '/Transformer/page/EE',
        name: 'Transformer_page/EE',
        component: () => import("../ZH-CN/forIfcores/Page4/EE"),
      },
      {
        path: '/Transformer/page/UF',
        name: 'Transformer_page/UF',
        component: () => import("../ZH-CN/forIfcores/Page4/UF"),
      },
      {
        path: '/Transformer/page/EC',
        name: 'Transformer_page/EC',
        component: () => import("../ZH-CN/forIfcores/Page4/EC"),
      },
      {
        path: '/Transformer/page/H',
        name: 'Transformer_page/H',
        component: () => import("../ZH-CN/forIfcores/Page4/huan"),
      },
      {
        path: '/Transformer/page/PQ',
        name: 'Transformer_page/PQ',
        component: () => import("../ZH-CN/forIfcores/Page4/PQ"),
      },
      {
        path: '/Transformer/page/EQ',
        name: 'Transformer_page/EQ',
        component: () => import("../ZH-CN/forIfcores/Page4/EQ"),
      },
      {
        path: '/Transformer/page/UY',
        name: 'Transformer_page/UY',
        component: () => import("../ZH-CN/forIfcores/Page4/UY"),
      },
      //  压制
      {
        path: '/Suppress/page/EE',
        name: 'Suppress_page2/EE',
        component: () => import("../ZH-CN/forIfcores/Page2/EE"),
      },
      {
        path: '/Suppress/page/EC',
        name: 'Suppress_page2/EC',
        component: () => import("../ZH-CN/forIfcores/Page2/EC"),
      },
      {
        path: '/Suppress/page/PQ',
        name: 'Suppress_page2/PQ',
        component: () => import("../ZH-CN/forIfcores/Page2/PQ"),
      },

      {
        path: '/search',
        name: '/search',
        component: () => import("../ZH-CN/forIfcores/search/search"),
      },

    ]
  },
  {
    path: '/scroll',
    name: 'scroll',
    component: () => import("../ZH-CN/components/scroll"),
  },
  {
    path: '/test',
    name: 'test',
    component: () => import("../ZH-CN/test"),
  },
  // ------------------------------------------------------------------------------------------------------------------------------------
  //--------制图

   // 英文
  {
    path: '/en',
    name: 'layout_EN',
    component: layout_EN,
    redirect: "/en/Home",
    children:[
      {
        path: '/en/Home',
        name: 'Home_EN',
        component: () => import("../EN/Home_CN"),
      },
       // 公司简介
      {
        path: '/About/en',
        name: 'About_EN',
        component: () => import("../EN/About"),
      },
      //  联系我们
      {
        path: '/Contact/en',
        name: 'Contact_EN',
        component: () => import("../EN/Contact"),
      },
      //  新闻

      {
        path: '/News/en',
        name: 'News_EN',
        component: () => import("../EN/News_CN"),
      },
       // 新闻详情

      {
        path: '/NewsDescription/en',
        name: 'NewsDescription_EN',
        component: () => import("../EN/news/NewsDescription"),
      },
       // 产品
      {
        path: '/Products/en',
        name: 'Products_EN',
        component: () => import("../EN/Products"),
        children:[
          //  制图
          {
            path: '/Products/Page1/en',
            name: 'Page1_EN',
            meta: {
              keepAlive: true,
              left: true,
              crumbs:false
            },
            component: () => import("../EN/calc/Page1"),
          },


        ]
      },

       // 隐私条款
      {
        path: '/PrivacyPolicy/en',
        name: 'PrivacyPolicy_EN',
        component: () => import("../EN/PrivacyPolicy"),

      },

      {
        path: '/Calc/Page1/deatail/en',
        name: 'page1/EE_EN',
        component: () => import("../EN/calc/Page1/EE"),
      },
      {
        path: '/en/Calc/Page1/1',
        name: 'page1/en/1',
        component: () => import("../EN/calc/Page1/mate"),

      },
        // 画图

  // ------------------------------------------------------------------------------------------------------------------------------------
      {
        path: '/Calc/page/EE/en',
        name: 'page/EE_EN',
        component: () => import("../EN/forIfcores/Page1/EE"),
      },
      {
        path: '/Calc/page/UF/en',
        name: 'page/UF_EN',
        component: () => import("../EN/forIfcores/Page1/UF"),
      },
      {
        path: '/Calc/page/EC/en',
        name: 'page/EC_EN',
        component: () => import("../EN/forIfcores/Page1/EC"),
      },
      {
        path: '/Calc/page/H/en',
        name: 'page/H_EN',
        component: () => import("../EN/forIfcores/Page1/huan"),
      },
      {
        path: '/Calc/page/PQ/en',
        name: 'page/PQ_EN',
        component: () => import("../EN/forIfcores/Page1/PQ"),
      },
      {
        path: '/Calc/page/EQ/en',
        name: 'page/EQ_EN',
        component: () => import("../EN/forIfcores/Page1/EQ"),
      },
      {
        path: '/Calc/page/UY/en',
        name: 'page/UY_EN',
        component: () => import("../EN/forIfcores/Page1/UY"),
      },
//   变压器
      {
        path: '/Transformer/page/EE/en',
        name: 'Transformer_page/EE_EN',
        component: () => import("../EN/forIfcores/Page4/EE"),
      },
      {
        path: '/Transformer/page/UF/en',
        name: 'Transformer_page/UF_EN',
        component: () => import("../EN/forIfcores/Page4/UF"),
      },
      {
        path: '/Transformer/page/EC/en',
        name: 'Transformer_page/EC_EN',
        component: () => import("../EN/forIfcores/Page4/EC"),
      },
      {
        path: '/Transformer/page/H/en',
        name: 'Transformer_page/H_EN',
        component: () => import("../EN/forIfcores/Page4/huan"),
      },
      {
        path: '/Transformer/page/PQ/en',
        name: 'Transformer_page/PQ_EN',
        component: () => import("../EN/forIfcores/Page4/PQ"),
      },
      {
        path: '/Transformer/page/EQ/en',
        name: 'Transformer_page/EQ_EN',
        component: () => import("../EN/forIfcores/Page4/EQ"),
      },
      {
        path: '/Transformer/page/UY/en',
        name: 'Transformer_page/UY_EN',
        component: () => import("../EN/forIfcores/Page4/UY"),
      },
      //  压制
      {
        path: '/Suppress/page/EE/en',
        name: 'Suppress_page2/EE_EN',
        component: () => import("../EN/forIfcores/Page2/EE"),
      },
      {
        path: '/Suppress/page/EC/en',
        name: 'Suppress_page2/EC_EN',
        component: () => import("../EN/forIfcores/Page2/EC"),
      },
      {
        path: '/Suppress/page/PQ/en',
        name: 'Suppress_page2/PQ_EN',
        component: () => import("../EN/forIfcores/Page2/PQ"),
      },

      {
        path: '/search',
        name: '/search_EN',
        component: () => import("../EN/forIfcores/search/search"),
      },


    ]
  },
    // ======================================================================================================
  // 德文
  {
    path: '/de',
    name: 'layout_de',
    component: layout_de,
    redirect: "/de/Home",
    children:[
      {
        path: '/de/Home',
        name: 'Home_de',
        component: () => import("../DE/Home_CN"),
      },
      // 公司简介
      {
        path: '/About/de',
        name: 'About_de',
        component: () => import("../DE/About"),
      },
      //  联系我们
      {
        path: '/Contact/de',
        name: 'Contact_de',
        component: () => import("../DE/Contact"),
      },
      //  新闻

      {
        path: '/News/de',
        name: 'News_de',
        component: () => import("../DE/News_CN"),
      },
      // 新闻详情

      {
        path: '/NewsDescription/de',
        name: 'NewsDescription_de',
        component: () => import("../DE/news/NewsDescription"),
      },
      // 产品
      {
        path: '/Products/de',
        name: 'Products_de',
        component: () => import("../DE/Products"),
        children:[
          //  制图
          {
            path: '/Products/Page1/de',
            name: 'Page1_de',
            meta: {
              keepAlive: true,
              left: true,
              crumbs:false
            },
            component: () => import("../DE/calc/Page1"),
          },

        ]
      },

      // 隐私条款
      {
        path: '/PrivacyPolicy/de',
        name: 'PrivacyPolicy_de',
        component: () => import("../DE/PrivacyPolicy"),

      },
      // --------制图路径--------
      {
        path: '/Calc/Page1/detail/de',
        name: 'page1/EE_de',
        component: () => import("../DE/calc/Page1/EE"),
      },
      {
        path: '/de/Calc/Page1/1',
        name: 'page1/de/1',
        component: () => import("../DE/calc/Page1/mate"),

      },
      // ------------------------------------------------------------------------------------------------------------------------------------
      // --------制图
      {
        path: '/Calc/page/EE/de',
        name: 'page/EE_de',
        component: () => import("../DE/forIfcores/Page1/EE"),
      },
      {
        path: '/Calc/page/UF/de',
        name: 'page/UF_de',
        component: () => import("../DE/forIfcores/Page1/UF"),
      },
      {
        path: '/Calc/page/EC/de',
        name: 'page/EC_de',
        component: () => import("../DE/forIfcores/Page1/EC"),
      },
      {
        path: '/Calc/page/H/de',
        name: 'page/H_de',
        component: () => import("../DE/forIfcores/Page1/huan"),
      },
      {
        path: '/Calc/page/PQ/de',
        name: 'page/PQ_de',
        component: () => import("../DE/forIfcores/Page1/PQ"),
      },
      {
        path: '/Calc/page/EQ/de',
        name: 'page/EQ_de',
        component: () => import("../DE/forIfcores/Page1/EQ"),
      },
      {
        path: '/Calc/page/UY/de',
        name: 'page/UY_de',
        component: () => import("../DE/forIfcores/Page1/UY"),
      },
      //   变压器
      {
        path: '/Transformer/page/EE/de',
        name: 'Transformer_page/EE_de',
        component: () => import("../EN/forIfcores/Page4/EE"),
      },
      {
        path: '/Transformer/page/UF/de',
        name: 'Transformer_page/UF_de',
        component: () => import("../EN/forIfcores/Page4/UF"),
      },
      {
        path: '/Transformer/page/EC/de',
        name: 'Transformer_page/EC_de',
        component: () => import("../EN/forIfcores/Page4/EC"),
      },
      {
        path: '/Transformer/page/H/de',
        name: 'Transformer_page/H_de',
        component: () => import("../EN/forIfcores/Page4/huan"),
      },
      {
        path: '/Transformer/page/PQ/de',
        name: 'Transformer_page/PQ_de',
        component: () => import("../EN/forIfcores/Page4/PQ"),
      },
      {
        path: '/Transformer/page/EQ/de',
        name: 'Transformer_page/EQ_de',
        component: () => import("../EN/forIfcores/Page4/EQ"),
      },
      {
        path: '/Transformer/page/UY/de',
        name: 'Transformer_page/UY_de',
        component: () => import("../EN/forIfcores/Page4/UY"),
      },
      //  压制
      {
        path: '/Suppress/page/EE/de',
        name: 'Suppress_page2/EE_de',
        component: () => import("../EN/forIfcores/Page2/EE"),
      },
      {
        path: '/Suppress/page/EC/de',
        name: 'Suppress_page2/EC_de',
        component: () => import("../EN/forIfcores/Page2/EC"),
      },
      {
        path: '/Suppress/page/PQ/de',
        name: 'Suppress_page2/PQ_de',
        component: () => import("../EN/forIfcores/Page2/PQ"),
      },

      {
        path: '/search',
        name: '/search_de',
        component: () => import("../EN/forIfcores/search/search"),
      },

    ]
  },
  // ======================================================================================================
  // 繁体
  {
    path: '/cht',
    name: 'layout_cht',
    component: layout_cht,
    redirect: "/cht/Home",
    children:[
      {
        path: '/cht/Home',
        name: 'Home_cht',
        component: () => import("../Cht/Home_CN"),
      },
      // 公司简介
      {
        path: '/About/cht',
        name: 'About_cht',
        component: () => import("../Cht/About"),
      },
      //  联系我们
      {
        path: '/Contact/cht',
        name: 'Contact_cht',
        component: () => import("../Cht/Contact"),
      },
      //  新闻

      {
        path: '/News/cht',
        name: 'News_cht',
        component: () => import("../Cht/News_CN"),
      },
      // 新闻详情

      {
        path: '/NewsDescription/cht',
        name: 'NewsDescription_cht',
        component: () => import("../Cht/news/NewsDescription"),
      },
      // 产品
      {
        path: '/Products/cht',
        name: 'Products_cht',
        component: () => import("../Cht/Products"),

        children:[
          //  制图
          {
            path: '/Products/Page1/cht',
            name: 'Page1_cht',
            meta: {
              keepAlive: true,
              left: true,
              crumbs:false
            },
            component: () => import("../Cht/calc/Page1"),
          },

        ]
      },

      // 隐私条款
      {
        path: '/PrivacyPolicy/cht',
        name: 'PrivacyPolicy_cht',
        component: () => import("../Cht/PrivacyPolicy"),

      },
      // --------制图路径--------
      {
        path: '/Calc/Page1/detail/cht',
        name: 'page1/EE_cht',
        component: () => import("../Cht/calc/Page1/EE"),
      },
      {
        path: '/cht/Calc/Page1/1',
        name: 'page1/cht/1',
        component: () => import("../Cht/calc/Page1/mate"),

      },
      // ------------------------------------------------------------------------------------------------------------------------------------
      // --------制图
      {
        path: '/Calc/page/EE/cht',
        name: 'page/EE_cht',
        component: () => import("../Cht/forIfcores/Page1/EE"),
      },
      {
        path: '/Calc/page/UF/cht',
        name: 'page/UF_cht',
        component: () => import("../Cht/forIfcores/Page1/UF"),
      },
      {
        path: '/Calc/page/EC/cht',
        name: 'page/EC_cht',
        component: () => import("../Cht/forIfcores/Page1/EC"),
      },
      {
        path: '/Calc/page/H/cht',
        name: 'page/H_cht',
        component: () => import("../Cht/forIfcores/Page1/huan"),
      },
      {
        path: '/Calc/page/PQ/cht',
        name: 'page/PQ_cht',
        component: () => import("../Cht/forIfcores/Page1/PQ"),
      },
      {
        path: '/Calc/page/EQ/cht',
        name: 'page/EQ_cht',
        component: () => import("../Cht/forIfcores/Page1/EQ"),
      },
      {
        path: '/Calc/page/UY/cht',
        name: 'page/UY_cht',
        component: () => import("../Cht/forIfcores/Page1/UY"),
      },
      // 画图

      // ------------------------------------------------------------------------------------------------------------------------------------
//   变压器
      {
        path: '/Transformer/page/EE/cht',
        name: 'Transformer_page/cht_ee',
        component: () => import("../Cht/forIfcores/Page4/EE"),
      },
      {
        path: '/Transformer/page/UF/cht',
        name: 'Transformer_page/cht_uf',
        component: () => import("../Cht/forIfcores/Page4/UF"),
      },
      {
        path: '/Transformer/page/EC/cht',
        name: 'Transformer_page/EC_cht',
        component: () => import("../Cht/forIfcores/Page4/EC"),
      },
      {
        path: '/Transformer/page/H/cht',
        name: 'Transformer_page/H_cht',
        component: () => import("../Cht/forIfcores/Page4/huan"),
      },
      {
        path: '/Transformer/page/PQ/cht',
        name: 'Transformer_page/PQ_cht',
        component: () => import("../Cht/forIfcores/Page4/PQ"),
      },
      {
        path: '/Transformer/page/EQ/cht',
        name: 'Transformer_page/EQ_cht',
        component: () => import("../Cht/forIfcores/Page4/EQ"),
      },
      {
        path: '/Transformer/page/UY/cht',
        name: 'Transformer_page/UY_cht',
        component: () => import("../Cht/forIfcores/Page4/UY"),
      },
      //  压制
      {
        path: '/Suppress/page/EE/cht',
        name: 'Suppress_page2/EE_cht',
        component: () => import("../Cht/forIfcores/Page2/EE"),
      },
      {
        path: '/Suppress/page/EC/cht',
        name: 'Suppress_page2/EC_cht',
        component: () => import("../Cht/forIfcores/Page2/EC"),
      },
      {
        path: '/Suppress/page/PQ/cht',
        name: 'Suppress_page2/PQ_cht',
        component: () => import("../Cht/forIfcores/Page2/PQ"),
      },

      {
        path: '/search',
        name: '/search_cht',
        component: () => import("../Cht/forIfcores/search/search"),
      },

    ]
  },
  {
    path: '/login',
    name: 'layout_login',
    component: () => import("../login/login"),
    },
  // {
  //   path: '/backStage_Management',
  //   name: 'backStage_Management',
  //   component: () => import("../login/success/backStage_Management"),
  // }

//    ------------------------------------------------
  {
    path: '/backStage_Management',
    name: 'backStage_Management',
    component: Aside,
    redirect: "/backStage_Management/About",
    children:[
      {
        path: '/backStage_Management/Home',
        name: 'home',
        component: () => import("../login/success/Home/home"),
      },

      {
        path: '/backStage_Management/About',
        name: 'about',
        component: () => import("../login/success/About/about"),
      },


      {
        path: '/backStage_Management/Product',
        name: 'product',
        component: () => import("../login/success/Product/product"),
      },
      {
        path: '/backStage_Management/Product/Add',
        name: 'Add',
        component: () => import("../login/success/Product/productAdd"),
      },
      {
        path: '/backStage_Management/Product/Category',
        name: 'category',
        component: () => import("../login/success/Product/productCategory"),
      },
      {
        path: '/backStage_Management/ContactUs',
        name: 'contactUs',
        component: () => import("../login/success/ContactUs/contactUs"),
      },
      {
        path: '/backStage_Management/News',
        name: 'news',
        component: () => import("../login/success/News/news"),
      },
      {
        path: '/backStage_Management/News/industryNews',
        name: 'industryNews',
        component: () => import("../login/success/News/industryNews"),
      },
      {
        path: '/backStage_Management/News/newsAdd',
        name: 'newsAdd',
        component: () => import("../login/success/News/newsAdd"),
      },

      {
        path: '/backStage_Management/Mate',
        name: 'Mate',
        component: () => import("../login/success/Mate/Mate"),
      },
      {
        path: '/backStage_Management/Mate/add',
        name: 'mateAdd',
        component: () => import("../login/success/Mate/newsAdd"),
      },
      {
        path: '/backStage_Management/Mate/chart',
        name: 'chart',
        component: () => import("../login/success/Mate/chart"),
      },
      {
        path: '/backStage_Management/Mate/chartAdd',
        name: 'chartAdd',
        component: () => import("../login/success/Mate/mateAdd"),
      },
      {
        path: '/backStage_Management/Log',
        name: 'log',
        component: () => import("../login/success/Log/Log"),
      },
    ]
  },


//   {
//     path: '/test',
//     name: 'test_EN',
//     component: () => import("../EN/test"),
//   },
//   // ------------------------------------------------------------------------------------------------------------------------------------
//   // --------制图


]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
